/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import Colors from '~global/Colors';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isMobileWeb, isNative } from '~global/screens';

// eslint-disable-next-line react/display-name
const BottomTab = ({ state, descriptors, navigation }) => {
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isModalUserQRShow = useSelector((state) => state.modal.userQR.isShow);
  const isModalChildrenList = useSelector(
    (state) => state.modal.childrenList.isShow,
  );
  const showTabInScreen = (screenIndex, screenName) => {
    return state.index == screenIndex &&
      state.routes.find((res) => res.name == screenName) &&
      (('state' in state.routes.find((res) => res.name == screenName) &&
        state.routes.find((res) => res.name == screenName).state.routes
          .length == 1) ||
        !('state' in state.routes.find((res) => res.name == screenName)))
      ? true
      : false;
  };

  const showTabInHomeStack = showTabInScreen(0, 'Shop');
  const showTabInTrackingStack = isNative
    ? showTabInScreen(1, 'Tracker')
    : false;
  const showTabInProfileStack =
    showTabInScreen(isNative ? 2 : 1, 'Profile') &&
    !isModalUserQRShow &&
    !isModalChildrenList
      ? true
      : false;

  const showTab =
    showTabInHomeStack || showTabInProfileStack || showTabInTrackingStack;

  const login = () => {
    if (!global.native) {
      dispatch({
        type: 'MODAL/SHOW',
        modalName: 'login',
        data: { navigation: navigation },
      });
    } else {
      navigation.navigate('LoginControlScreen', { title: 'Login' });
    }
  };

  return (
    <>
      {showTab && (
        <View
          style={[
            styles.container,
            isMobileWeb ? styles.mobileWebContainer : {},
          ]}>
          {state.routes.map((route, index) => {
            const { options } = descriptors[route.key];
            const label =
              options.tabBarLabel !== undefined
                ? options.tabBarLabel
                : options.title !== undefined
                ? options.title
                : route.name;

            const isFocused = state.index === index;

            const onPress = () => {
              const event = navigation.emit({
                type: 'tabPress',
                target: route.key,
              });

              if (!isLoggedIn && route.name !== 'Home') {
                if (route.name == 'Shop') {
                  navigation.navigate('HomeScreen');
                } else {
                  login();
                  return;
                }
              }

              if (global.isMobileWeb && route.name === 'Profile') {
                navigation.navigate('Profile', {
                  screen: 'ProfileScreen',
                });
                return;
              }

              if (!isFocused && !event.defaultPrevented) {
                navigation.navigate(route.name);
              }
            };

            const onLongPress = () => {
              navigation.emit({
                type: 'tabLongPress',
                target: route.key,
              });
            };

            let labelIcon = '';
            if (label === 'Shop') {
              labelIcon = require('~assets/img/bottom-navigation/shop.svg');
              if (isFocused) {
                labelIcon = require('~assets/img/bottom-navigation/shop-active.svg');
              }
            } else if (label === 'Tracker') {
              labelIcon = require('~assets/img/bottom-navigation/tracking.svg');
              if (isFocused) {
                labelIcon = require('~assets/img/bottom-navigation/tracking-active.svg');
              }
            } else {
              labelIcon = require('~assets/img/bottom-navigation/profile.svg');
              if (isFocused) {
                labelIcon = require('~assets/img/bottom-navigation/profile-active.svg');
              }
            }

            return (
              <Pressable
                accessibilityRole="button"
                accessibilityState={isFocused ? { selected: true } : {}}
                accessibilityLabel={options.tabBarAccessibilityLabel}
                testID={options.tabBarTestID}
                onPress={onPress}
                onLongPress={onLongPress}
                key={index}
                style={[
                  styles.tabArea,
                  { marginBottom: insets.bottom },
                  isMobileWeb ? styles.marginAuto : {},
                ]}>
                <View style={[styles.tab, isFocused ? styles.tabFocused : '']}>
                  <WithLocalSvg
                    width="17"
                    height="16"
                    asset={labelIcon}
                    style={styles.icon}
                  />
                  <Text
                    style={[styles.text, isFocused ? styles.textFocused : '']}>
                    {label}
                  </Text>
                </View>
              </Pressable>
            );
          })}
        </View>
      )}
      {showTab && (
        <View style={{ ...styles.shadow1, bottom: insets.bottom + 50 }}></View>
      )}
      {showTab && (
        <View style={{ ...styles.shadow2, bottom: insets.bottom + 51 }}></View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    zIndex: 3,
    flexDirection: 'row',
    position: 'absolute',
    bottom: 0,
    backgroundColor: '#fff',
  },
  marginAuto: {
    margin: 'auto',
  },
  mobileWebContainer: {
    width: '100%',
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    ...(isMobileWeb
      ? {
          boxShadow: '0 -2px 4px 0 rgba(0,0,0,0.08)',
        }
      : {}),
  },
  shadow1: {
    width: '100%',
    height: 1,
    zIndex: 2,
    backgroundColor: 'rgba(0,0,0,.04)',
    position: 'absolute',
    overflow: 'hidden',
  },
  shadow2: {
    width: '100%',
    height: 1,
    zIndex: 1,
    backgroundColor: 'rgba(0,0,0,.03)',
    position: 'absolute',
    overflow: 'hidden',
  },
  icon: {
    marginRight: 6,
  },
  tabArea: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 8,
    paddingBottom: 8,
    flex: 1,
    backgroundColor: '#fff',
    height: isMobileWeb ? 48 : 50,
  },
  tab: {
    flexDirection: 'row',
    paddingVertical: 7,
    paddingHorizontal: 17,
    borderRadius: 8,
    height: 32,
    width: 100,
    alignItems: 'center',
    overflow: 'hidden',
  },
  tabFocused: {
    borderRadius: 8,
    color: '#A179C5',
    backgroundColor: '#F3F0FC',
  },
  text: {
    fontSize: 14,
    lineHeight: 16,
    fontFamily: 'satoshi-bold',
    color: '#404040',
  },
  textFocused: {
    color: Colors.purple0,
  },
});

export default BottomTab;
